import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const examList = createAsyncThunk('examList', async ({ pageable: data, navigate, status, allBranches }) => { try { const res = await axios({ method: 'GET',
            url: getConfig.API_URL + `exam?status=${status || ''}`,
            params: { 'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                ...(allBranches ? { all_branches: true } : {}),
                ...(data?.instituteId ? { institute_id: data.instituteId } : {}),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) { return error.response
    }
})

const examListSlice = createSlice({ name: 'examList',
    initialState: { data: [] },
    extraReducers: (builder) => { builder.addCase(examList.fulfilled, (state, action) => { if (action?.payload?.status === 200) { state.data = (() => { const raw = action.payload.data.data; return Array.isArray(raw) ? raw : (Object.values(raw || {}).find(Array.isArray) || []); })();
            } else if (action?.payload?.status === 401) { showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) { showAccessDeniedAlert(action.meta.arg.navigate)
            } else { state.data = []
            }
        });
    }
})

export default examListSlice.reducer;
